import React from 'react';
import { groupSupplierDocuments } from 'features/supplier/utils';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';

import SupplierDocumentUpload from '@features/supplier/component/SupplierDocumentUpload';

const AddSupportingDocuments = ({ onClose, documentResponseList, callBack, documentTypes }) => {
	const handleSubmit = async () => {
		onClose();
	};

	const renderDocumentUpload = () => {
		const groupedDocuments = groupSupplierDocuments(documentResponseList, 'supportingDocumentType');
		return documentTypes?.map((item) => {
			let existingDocuments = groupedDocuments[item.id]?.map((existingDoc) => ({
				...existingDoc.documentResponse
			}));
			return (
				<React.Fragment key={`document_upload_${item.id}`}>
					<SupplierDocumentUpload
						title={item.value}
						fieldName={item.id}
						multiple={false}
						uploadType="SUPPORTING_DOCUMENT"
						callBack={callBack}
						documents={{ [item.id]: existingDocuments }}
					/>
				</React.Fragment>
			);
		});
	};

	return (
		<ModalContainer className="filter-quick-search-modal safety-info-modal">
			<div className="common-popup">
				<ModalHeader title="Additional Information" onClose={onClose} />

				<div className="common-popup-body scroll-y-label">
					<div className="container px-0">
						<div className="row">
							<div className="col-md-12">
								<div className="quick-info-files">{renderDocumentUpload()}</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onClose}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={handleSubmit}>
							Submit
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AddSupportingDocuments;
